import React from 'react'
import { Box, Button, Card, CardContent, Chip, Container, Stack, Typography } from '@mui/material'

const shellStyles = {
    page: {
        py: { xs: 3, md: 4 },
    },
    hero: {
        borderRadius: 6,
        overflow: 'hidden',
        background:
            'linear-gradient(135deg, rgba(42,27,102,1) 0%, rgba(91,46,255,1) 100%)',
        boxShadow: '0 28px 60px rgba(49,26,137,0.38)',
    },
    panel: {
        borderRadius: 6,
        background: 'rgba(27,16,64,0.96)',
        border: '1px solid rgba(183,166,255,0.16)',
    },
    softPanel: {
        p: 2,
        borderRadius: 4,
        bgcolor: 'rgba(91,46,255,0.10)',
        border: '1px solid rgba(183,166,255,0.16)',
        height: '100%',
    },
}

export default function MerchantToolShell({
    eyebrow,
    title,
    subtitle,
    chips = [],
    primaryAction,
    secondaryAction,
    left,
    right,
    bottom,
}) {
    return (
        <Container maxWidth="lg" sx={shellStyles.page}>
            <Stack spacing={3}>
                <Card sx={shellStyles.hero}>
                    <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                        <Stack spacing={2.5}>
                            <Stack
                                direction={{ xs: 'column', md: 'row' }}
                                justifyContent="space-between"
                                spacing={2}
                            >
                                <Box>
                                    <Typography sx={{ color: 'rgba(255,255,255,0.74)', mb: 1 }}>
                                        {eyebrow}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: '#FFFFFF',
                                            fontWeight: 900,
                                            fontSize: { xs: 30, md: 42 },
                                            letterSpacing: '-0.03em',
                                        }}
                                    >
                                        {title}
                                    </Typography>
                                    <Typography sx={{ color: 'rgba(255,255,255,0.80)', mt: 1, maxWidth: 760 }}>
                                        {subtitle}
                                    </Typography>
                                </Box>

                                {chips.length > 0 && (
                                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                                        {chips.map((chip) => (
                                            <Chip
                                                key={chip}
                                                label={chip}
                                                sx={{ color: '#FFF', bgcolor: 'rgba(255,255,255,0.14)' }}
                                            />
                                        ))}
                                    </Stack>
                                )}
                            </Stack>

                            {(primaryAction || secondaryAction) && (
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
                                    {primaryAction && (
                                        <Button
                                            variant="contained"
                                            onClick={primaryAction.onClick}
                                            sx={{
                                                bgcolor: '#FFFFFF',
                                                color: '#0B0620',
                                                fontWeight: 900,
                                                borderRadius: 4,
                                                textTransform: 'none',
                                                px: 3,
                                            }}
                                        >
                                            {primaryAction.label}
                                        </Button>
                                    )}
                                    {secondaryAction && (
                                        <Button
                                            variant="outlined"
                                            onClick={secondaryAction.onClick}
                                            sx={{
                                                color: '#FFFFFF',
                                                borderColor: 'rgba(183,166,255,0.34)',
                                                fontWeight: 800,
                                                borderRadius: 4,
                                                textTransform: 'none',
                                                px: 3,
                                            }}
                                        >
                                            {secondaryAction.label}
                                        </Button>
                                    )}
                                </Stack>
                            )}
                        </Stack>
                    </CardContent>
                </Card>

                <Box
                    sx={{
                        display: 'grid',
                        gap: 3,
                        gridTemplateColumns: { xs: '1fr', md: right ? '1.3fr 0.9fr' : '1fr' },
                    }}
                >
                    <Card sx={shellStyles.panel}>
                        <CardContent sx={{ p: 3 }}>{left}</CardContent>
                    </Card>
                    {right && (
                        <Card sx={shellStyles.panel}>
                            <CardContent sx={{ p: 3 }}>{right}</CardContent>
                        </Card>
                    )}
                </Box>

                {bottom && (
                    <Card sx={shellStyles.panel}>
                        <CardContent sx={{ p: 3 }}>{bottom}</CardContent>
                    </Card>
                )}
            </Stack>
        </Container>
    )
}

export { shellStyles }
